import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
    return (
        <footer className="footer py-4 mt-5 border-top">
            <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
                <p className="mb-0 text-muted">
                    © {new Date().getFullYear()} Bysetup. Todos os direitos reservados.
                </p>

                <nav className="d-flex align-items-center gap-3">
                    <Link to="/sobre" className="footer-link">Sobre</Link>
                    <Link to="/contato" className="footer-link">Contato</Link>
                </nav>

            </div>
        </footer>
    )
}